module.exports = __webpack_public_path__ + "static/img/房屋模型.8a22a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/房屋模型.jpg
// module id = awSD
// module chunks = 1